import { render, staticRenderFns } from "./RecordAutomatedFollowUpCard.vue?vue&type=template&id=b81edd04&scoped=true&"
import script from "./RecordAutomatedFollowUpCard.vue?vue&type=script&lang=js&"
export * from "./RecordAutomatedFollowUpCard.vue?vue&type=script&lang=js&"
import style0 from "./RecordAutomatedFollowUpCard.vue?vue&type=style&index=0&id=b81edd04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81edd04",
  null
  
)

export default component.exports